export default "__VITE_ASSET__B1PmYB$M__"